//перевод контента в демо сделки
const translation: Record<string, Record<string, string>> = {
  inviteHook1: {
    ru: "Сделка закрыта 🔥 — Apple Inc, спустя 2 Месяца",
    en: "Closed the trade 🔥 — Apple Inc, after 2 Months",
    es: "Operación cerrada 🔥 — Apple Inc, después de 2 Meses",
    pt: "Trade fechado 🔥 — Apple Inc, depois de 2 Meses",
    de: "Trade geschlossen 🔥 — Apple Inc, nach 2 Monaten",
    fr: "Trade clôturé 🔥 — Apple Inc, après 2 Mois",
  },
  inviteHook2: {
    ru: "Apple Inc, спустя 2 Месяца — 🔥 позиция завершена",
    en: "Apple Inc, after 2 Months — 🔥 position done",
    es: "Apple Inc, después de 2 Meses — 🔥 posición completada",
    pt: "Apple Inc, depois de 2 Meses — 🔥 posição concluída",
    de: "Apple Inc, nach 2 Monaten — 🔥 Position beendet",
    fr: "Apple Inc, après 2 Mois — 🔥 position terminée",
  },
  inviteHook3: {
    ru: "Финальное движение 🔥 по Apple Inc",
    en: "Final move 🔥 on Apple Inc",
    es: "Movimiento final 🔥 en Apple Inc",
    pt: "Último movimento 🔥 em Apple Inc",
    de: "Letzter Move 🔥 bei Apple Inc",
    fr: "Dernier move 🔥 sur Apple Inc",
  },
  inviteHook4: {
    ru: "Apple Inc — 🔥 сделка завершена",
    en: "Apple Inc — 🔥 trade completed",
    es: "Apple Inc — 🔥 operación completada",
    pt: "Apple Inc — 🔥 operação concluída",
    de: "Apple Inc — 🔥 Trade abgeschlossen",
    fr: "Apple Inc — 🔥 trade complété",
  },
  inviteHook5: {
    ru: "Сделка закрыта через 2 Месяца 🔥 — Apple Inc",
    en: "Trade closed after 2 Months 🔥 — Apple Inc",
    es: "Operación cerrada tras 2 Meses 🔥 — Apple Inc",
    pt: "Trade fechado após 2 Meses 🔥 — Apple Inc",
    de: "Trade beendet nach 2 Monaten 🔥 — Apple Inc",
    fr: "Trade fermé après 2 Mois 🔥 — Apple Inc",
  },
  inviteHook6: {
    ru: "Apple Inc, 🔥 удержание завершено",
    en: "Apple Inc, 🔥 steady hold — done",
    es: "Apple Inc, 🔥 posición mantenida — lista",
    pt: "Apple Inc, 🔥 posição mantida — concluída",
    de: "Apple Inc, 🔥 stabil gehalten — fertig",
    fr: "Apple Inc, 🔥 maintien stable — terminé",
  },
  inviteHook7: {
    ru: "Торговый цикл завершён 🔥 — Apple Inc",
    en: "Trade cycle complete 🔥 — Apple Inc",
    es: "Ciclo de trading completo 🔥 — Apple Inc",
    pt: "Ciclo de trade completo 🔥 — Apple Inc",
    de: "Handelszyklus abgeschlossen 🔥 — Apple Inc",
    fr: "Cycle de trade complété 🔥 — Apple Inc",
  },
  inviteHook8: {
    ru: "Позиция закрыта 🔥 — Apple Inc, спустя 2 Месяца",
    en: "Position wrapped 🔥 — Apple Inc, after 2 Months",
    es: "Posición cerrada 🔥 — Apple Inc, después de 2 Meses",
    pt: "Posição encerrada 🔥 — Apple Inc, depois de 2 Meses",
    de: "Position geschlossen 🔥 — Apple Inc, nach 2 Monaten",
    fr: "Position clôturée 🔥 — Apple Inc, après 2 Mois",
  },
  inviteHook9: {
    ru: "Apple Inc — 🔥 чистый выход",
    en: "Apple Inc — 🔥 clear exit",
    es: "Apple Inc — 🔥 salida limpia",
    pt: "Apple Inc — 🔥 saída limpa",
    de: "Apple Inc — 🔥 klarer Exit",
    fr: "Apple Inc — 🔥 sortie claire",
  },
  inviteHook10: {
    ru: "Apple Inc, 🔥 сделка завершена через 2 Месяца",
    en: "Apple Inc, 🔥 trade finished after 2 Months",
    es: "Apple Inc, 🔥 operación cerrada después de 2 Meses",
    pt: "Apple Inc, 🔥 operação finalizada após 2 Meses",
    de: "Apple Inc, 🔥 abgeschlossen nach 2 Monaten",
    fr: "Apple Inc, 🔥 clôturé après 2 Mois",
  },
  inviteHook11: {
    ru: "Apple Inc 🔥 закрыта через 2 Месяца",
    en: "Apple Inc 🔥 closed after 2 Months",
    es: "Apple Inc 🔥 cerrada tras 2 Meses",
    pt: "Apple Inc 🔥 fechada após 2 Meses",
    de: "Apple Inc 🔥 geschlossen nach 2 Monaten",
    fr: "Apple Inc 🔥 clôturée après 2 Mois",
  },
  inviteHook12: {
    ru: "Сделка завершена — 🔥 Apple Inc, спустя 2 Месяца",
    en: "Trade finished — 🔥 Apple Inc, after 2 Months",
    es: "Operación completada — 🔥 Apple Inc, después de 2 Meses",
    pt: "Operação encerrada — 🔥 Apple Inc, depois de 2 Meses",
    de: "Abgeschlossen — 🔥 Apple Inc, nach 2 Monaten",
    fr: "Trade terminé — 🔥 Apple Inc, après 2 Mois",
  },
  inviteHook13: {
    ru: "Apple Inc 🔥 — цикл завершён",
    en: "Apple Inc 🔥 — cycle complete",
    es: "Apple Inc 🔥 — ciclo finalizado",
    pt: "Apple Inc 🔥 — ciclo concluído",
    de: "Apple Inc 🔥 — Zyklus beendet",
    fr: "Apple Inc 🔥 — cycle terminé",
  },
  inviteHook14: {
    ru: "Сделка завершена через 2 Месяца 🔥 — Apple Inc",
    en: "Trade done after 2 Months 🔥 — Apple Inc",
    es: "Operación terminada después de 2 Meses 🔥 — Apple Inc",
    pt: "Trade concluído após 2 Meses 🔥 — Apple Inc",
    de: "Trade beendet nach 2 Monaten 🔥 — Apple Inc",
    fr: "Trade terminé après 2 Mois 🔥 — Apple Inc",
  },
  inviteHook15: {
    ru: "Apple Inc — 🔥 позиция закрыта",
    en: "Apple Inc — 🔥 position wrapped up",
    es: "Apple Inc — 🔥 posición finalizada",
    pt: "Apple Inc — 🔥 posição encerrada",
    de: "Apple Inc — 🔥 Position abgeschlossen",
    fr: "Apple Inc — 🔥 position bouclée",
  },
  inviteHook16: {
    ru: "Закрыл позицию 🔥 — Apple Inc",
    en: "Closed out 🔥 — Apple Inc",
    es: "Cerrada 🔥 — Apple Inc",
    pt: "Encerrado 🔥 — Apple Inc",
    de: "Geschlossen 🔥 — Apple Inc",
    fr: "Clôturé 🔥 — Apple Inc",
  },
  inviteHook17: {
    ru: "Apple Inc, 🔥 закрыта через 2 Месяца",
    en: "Apple Inc, 🔥 trade closed after 2 Months",
    es: "Apple Inc, 🔥 cerrada después de 2 Meses",
    pt: "Apple Inc, 🔥 fechado após 2 Meses",
    de: "Apple Inc, 🔥 beendet nach 2 Monaten",
    fr: "Apple Inc, 🔥 clôturé après 2 Mois",
  },
  inviteHook18: {
    ru: "Apple Inc 🔥 — сделка завершена",
    en: "Apple Inc 🔥 — trade over",
    es: "Apple Inc 🔥 — operación finalizada",
    pt: "Apple Inc 🔥 — trade finalizado",
    de: "Apple Inc 🔥 — Trade vorbei",
    fr: "Apple Inc 🔥 — trade fini",
  },
  inviteHook19: {
    ru: "Завершил сделку 🔥 — Apple Inc",
    en: "Wrapped it up 🔥 — Apple Inc",
    es: "Cerré la operación 🔥 — Apple Inc",
    pt: "Encerrado 🔥 — Apple Inc",
    de: "Abgeschlossen 🔥 — Apple Inc",
    fr: "Fini 🔥 — Apple Inc",
  },
  inviteHook20: {
    ru: "Сделка чисто закрыта через 2 Месяца 🔥 — Apple Inc",
    en: "Trade closed clean after 2 Months 🔥 — Apple Inc",
    es: "Operación limpia tras 2 Meses 🔥 — Apple Inc",
    pt: "Trade limpo após 2 Meses 🔥 — Apple Inc",
    de: "Trade sauber beendet nach 2 Monaten 🔥 — Apple Inc",
    fr: "Trade proprement clôturé après 2 Mois 🔥 — Apple Inc",
  },
  inviteHook21: {
    ru: "Apple Inc 🔥 — одна сделка завершена",
    en: "Apple Inc 🔥 — one trade done",
    es: "Apple Inc 🔥 — una operación lista",
    pt: "Apple Inc 🔥 — um trade concluído",
    de: "Apple Inc 🔥 — ein Trade fertig",
    fr: "Apple Inc 🔥 — un trade terminé",
  },
  inviteHook22: {
    ru: "Сделка завершена 🔥 — Apple Inc",
    en: "Trade completed 🔥 — Apple Inc",
    es: "Operación completada 🔥 — Apple Inc",
    pt: "Trade completo 🔥 — Apple Inc",
    de: "Trade komplett 🔥 — Apple Inc",
    fr: "Trade complété 🔥 — Apple Inc",
  },
  inviteHook23: {
    ru: "Apple Inc — 🔥 выход подтверждён",
    en: "Apple Inc — 🔥 exit confirmed",
    es: "Apple Inc — 🔥 salida confirmada",
    pt: "Apple Inc — 🔥 saída confirmada",
    de: "Apple Inc — 🔥 Exit bestätigt",
    fr: "Apple Inc — 🔥 sortie confirmée",
  },
  inviteHook24: {
    ru: "Позиция закрыта 🔥 — Apple Inc, спустя 2 Месяца",
    en: "Position closed 🔥 — Apple Inc, after 2 Months",
    es: "Posición cerrada 🔥 — Apple Inc, después de 2 Meses",
    pt: "Posição encerrada 🔥 — Apple Inc, depois de 2 Meses",
    de: "Position geschlossen 🔥 — Apple Inc, nach 2 Monaten",
    fr: "Position clôturée 🔥 — Apple Inc, après 2 Mois",
  },
  inviteHook25: {
    ru: "Apple Inc 🔥 завершена чисто",
    en: "Apple Inc 🔥 done and clear",
    es: "Apple Inc 🔥 completada y clara",
    pt: "Apple Inc 🔥 concluída e limpa",
    de: "Apple Inc 🔥 sauber beendet",
    fr: "Apple Inc 🔥 terminé et clair",
  },
  inviteHook26: {
    ru: "Сделка завершена 🔥 — Apple Inc",
    en: "Wrapped and closed 🔥 — Apple Inc",
    es: "Operación cerrada 🔥 — Apple Inc",
    pt: "Fechado e concluído 🔥 — Apple Inc",
    de: "Abgeschlossen und beendet 🔥 — Apple Inc",
    fr: "Fermé et bouclé 🔥 — Apple Inc",
  },
  inviteHook27: {
    ru: "Apple Inc — 🔥 сделка завершена правильно",
    en: "Apple Inc — 🔥 trade finished right",
    es: "Apple Inc — 🔥 operación bien cerrada",
    pt: "Apple Inc — 🔥 trade bem finalizado",
    de: "Apple Inc — 🔥 Trade gut beendet",
    fr: "Apple Inc — 🔥 trade bien terminé",
  },
  inviteHook28: {
    ru: "Финальный результат 🔥 — Apple Inc",
    en: "Final result 🔥 — Apple Inc",
    es: "Resultado final 🔥 — Apple Inc",
    pt: "Resultado final 🔥 — Apple Inc",
    de: "Endergebnis 🔥 — Apple Inc",
    fr: "Résultat final 🔥 — Apple Inc",
  },
  inviteHook29: {
    ru: "Сделка завершена 🔥 — Apple Inc, чистый выход",
    en: "Trade done 🔥 — Apple Inc, clean exit",
    es: "Operación terminada 🔥 — Apple Inc, salida limpia",
    pt: "Trade feito 🔥 — Apple Inc, saída limpa",
    de: "Trade erledigt 🔥 — Apple Inc, sauberer Exit",
    fr: "Trade terminé 🔥 — Apple Inc, sortie propre",
  },
  inviteHook30: {
    ru: "Apple Inc 🔥 закрыта стабильно",
    en: "Apple Inc 🔥 closed out solid",
    es: "Apple Inc 🔥 cerrada de forma estable",
    pt: "Apple Inc 🔥 fechada com solidez",
    de: "Apple Inc 🔥 sauber geschlossen",
    fr: "Apple Inc 🔥 clôturé proprement",
  },
  inviteHook31: {
    ru: "Чистое завершение 🔥 по Apple Inc",
    en: "Clean finish 🔥 on Apple Inc",
    es: "Cierre limpio 🔥 en Apple Inc",
    pt: "Encerramento limpo 🔥 em Apple Inc",
    de: "Sauberes Ende 🔥 bei Apple Inc",
    fr: "Fin nette 🔥 sur Apple Inc",
  },
  inviteHook32: {
    ru: "Сделка завершена через 2 Месяца 🔥 — Apple Inc",
    en: "Trade done after 2 Months 🔥 — Apple Inc",
    es: "Operación terminada después de 2 Meses 🔥 — Apple Inc",
    pt: "Trade concluído após 2 Meses 🔥 — Apple Inc",
    de: "Trade beendet nach 2 Monaten 🔥 — Apple Inc",
    fr: "Trade terminé après 2 Mois 🔥 — Apple Inc",
  },
  inviteHook33: {
    ru: "Apple Inc — 🔥 плавное закрытие",
    en: "Apple Inc — 🔥 smooth close",
    es: "Apple Inc — 🔥 cierre suave",
    pt: "Apple Inc — 🔥 fechamento suave",
    de: "Apple Inc — 🔥 ruhiger Abschluss",
    fr: "Apple Inc — 🔥 clôture fluide",
  },
  inviteHook34: {
    ru: "Завершил 🔥 сделку по Apple Inc на этой неделе",
    en: "Wrapped 🔥 up Apple Inc this week",
    es: "Cerré 🔥 Apple Inc esta semana",
    pt: "Encerrado 🔥 Apple Inc nesta semana",
    de: "Diese 🔥 Woche abgeschlossen — Apple Inc",
    fr: "Bouclé 🔥 cette semaine — Apple Inc",
  },
  inviteHook35: {
    ru: "Apple Inc — 🔥 стабильное закрытие сделки",
    en: "Apple Inc — 🔥 trade closed steady",
    es: "Apple Inc — 🔥 cierre estable",
    pt: "Apple Inc — 🔥 fechamento constante",
    de: "Apple Inc — 🔥 stabil beendet",
    fr: "Apple Inc — 🔥 clôture stable",
  },
  inviteHook36: {
    ru: "Позиция завершена 🔥 — Apple Inc",
    en: "Position done 🔥 — Apple Inc",
    es: "Posición completada 🔥 — Apple Inc",
    pt: "Posição concluída 🔥 — Apple Inc",
    de: "Position fertig 🔥 — Apple Inc",
    fr: "Position finie 🔥 — Apple Inc",
  },
  inviteHook37: {
    ru: "Сделка завершена 🔥 — Apple Inc",
    en: "Trade complete 🔥 — Apple Inc",
    es: "Operación completa 🔥 — Apple Inc",
    pt: "Trade completo 🔥 — Apple Inc",
    de: "Trade abgeschlossen 🔥 — Apple Inc",
    fr: "Trade complété 🔥 — Apple Inc",
  },
  inviteHook38: {
    ru: "Apple Inc — 🔥 финальный шаг завершён",
    en: "Apple Inc — 🔥 final step done",
    es: "Apple Inc — 🔥 último paso hecho",
    pt: "Apple Inc — 🔥 último passo concluído",
    de: "Apple Inc — 🔥 letzter Schritt erledigt",
    fr: "Apple Inc — 🔥 dernière étape terminée",
  },
  inviteHook39: {
    ru: "Apple Inc, 🔥 позиция закрыта через 2 Месяца",
    en: "Apple Inc, 🔥 trade wrapped up after 2 Months",
    es: "Apple Inc, 🔥 cerrada tras 2 Meses",
    pt: "Apple Inc, 🔥 encerrada após 2 Meses",
    de: "Apple Inc, 🔥 abgeschlossen nach 2 Monaten",
    fr: "Apple Inc, 🔥 clôturé après 2 Mois",
  },
  inviteHook40: {
    ru: "Сделка 🔥 по Apple Inc завершена чисто",
    en: "Trade 🔥 on Apple Inc finished clean",
    es: "Operación 🔥 en Apple Inc completada limpia",
    pt: "Trade 🔥 em Apple Inc finalizado com clareza",
    de: "Trade 🔥 bei Apple Inc sauber beendet",
    fr: "Trade 🔥 sur Apple Inc terminé proprement",
  },
  inviteHook41: {
    ru: "Apple Inc — 🔥 сделка оформлена",
    en: "Apple Inc — 🔥 deal wrapped",
    es: "Apple Inc — 🔥 operación cerrada",
    pt: "Apple Inc — 🔥 operação encerrada",
    de: "Apple Inc — 🔥 Deal beendet",
    fr: "Apple Inc — 🔥 deal bouclé",
  },
  inviteHook42: {
    ru: "Выход из позиции 🔥 — Apple Inc",
    en: "Position exit 🔥 — Apple Inc",
    es: "Salida de posición 🔥 — Apple Inc",
    pt: "Saída de posição 🔥 — Apple Inc",
    de: "Position verlassen 🔥 — Apple Inc",
    fr: "Sortie de position 🔥 — Apple Inc",
  },
  inviteHook43: {
    ru: "Сделка завершена 🔥 через 2 Месяца — Apple Inc",
    en: "Trade done 🔥 after 2 Months — Apple Inc",
    es: "Operación completada 🔥 tras 2 Meses — Apple Inc",
    pt: "Trade concluído 🔥 após 2 Meses — Apple Inc",
    de: "Trade beendet 🔥 nach 2 Monaten — Apple Inc",
    fr: "Trade terminé 🔥 après 2 Mois — Apple Inc",
  },
  inviteHook44: {
    ru: "Apple Inc 🔥 закрыта чисто",
    en: "Apple Inc 🔥 closed clean",
    es: "Apple Inc 🔥 cerrada limpia",
    pt: "Apple Inc 🔥 fechada limpa",
    de: "Apple Inc 🔥 sauber geschlossen",
    fr: "Apple Inc 🔥 clôturé propre",
  },
  inviteHook45: {
    ru: "Торговый цикл 🔥 — Apple Inc, спустя 2 Месяца",
    en: "Trade cycle 🔥 — Apple Inc, after 2 Months",
    es: "Ciclo de trading 🔥 — Apple Inc, después de 2 Meses",
    pt: "Ciclo de trade 🔥 — Apple Inc, depois de 2 Meses",
    de: "Handelszyklus 🔥 — Apple Inc, nach 2 Monaten",
    fr: "Cycle de trade 🔥 — Apple Inc, après 2 Mois",
  },
  inviteHook46: {
    ru: "Apple Inc — 🔥 сделка урегулирована",
    en: "Apple Inc — 🔥 trade settled",
    es: "Apple Inc — 🔥 operación liquidada",
    pt: "Apple Inc — 🔥 operação finalizada",
    de: "Apple Inc — 🔥 Trade geregelt",
    fr: "Apple Inc — 🔥 trade réglé",
  },
  inviteHook47: {
    ru: "Завершил движение 🔥 — Apple Inc",
    en: "Wrapped my move 🔥 — Apple Inc",
    es: "Cerré el movimiento 🔥 — Apple Inc",
    pt: "Movimento encerrado 🔥 — Apple Inc",
    de: "Bewegung abgeschlossen 🔥 — Apple Inc",
    fr: "Mouvement terminé 🔥 — Apple Inc",
  },
  inviteHook48: {
    ru: "Apple Inc, сделка закрыта 🔥 через 2 Месяца",
    en: "Apple Inc, trade over 🔥 after 2 Months",
    es: "Apple Inc, cerrada después 🔥 de 2 Meses",
    pt: "Apple Inc, encerrada 🔥 após 2 Meses",
    de: "Apple Inc, vorbei 🔥 nach 2 Monaten",
    fr: "Apple Inc, fini 🔥 après 2 Mois",
  },
  inviteHook49: {
    ru: "Финальный шаг сделки 🔥 — Apple Inc",
    en: "Final trade step 🔥 — Apple Inc",
    es: "Paso final 🔥 — Apple Inc",
    pt: "Etapa final 🔥 — Apple Inc",
    de: "Letzter Schritt 🔥 — Apple Inc",
    fr: "Dernière étape du trade 🔥 — Apple Inc",
  },
  inviteHook50: {
    ru: "Apple Inc — 🔥 позиция чистая",
    en: "Apple Inc — 🔥 position clear",
    es: "Apple Inc — 🔥 posición clara",
    pt: "Apple Inc — 🔥 posição clara",
    de: "Apple Inc — 🔥 Position klar",
    fr: "Apple Inc — 🔥 position claire",
  },
  inviteHook51: {
    ru: "Apple Inc, 🔥 позиция завершена через 2 Месяца",
    en: "Apple Inc, 🔥 position finished after 2 Months",
    es: "Apple Inc, 🔥 posición cerrada después de 2 Meses",
    pt: "Apple Inc, 🔥 posição concluída após 2 Meses",
    de: "Apple Inc, 🔥 Position beendet nach 2 Monaten",
    fr: "Apple Inc, 🔥 position terminée après 2 Mois",
  },
  inviteHook52: {
    ru: "Сделка завершена 🔥 — Apple Inc",
    en: "Trade wrapped 🔥 — Apple Inc",
    es: "Operación cerrada 🔥 — Apple Inc",
    pt: "Trade encerrado 🔥 — Apple Inc",
    de: "Trade abgeschlossen 🔥 — Apple Inc",
    fr: "Trade bouclé 🔥 — Apple Inc",
  },
  inviteHook53: {
    ru: "Apple Inc — 🔥 всё готово, завершено",
    en: "Apple Inc — 🔥 all set, done",
    es: "Apple Inc — 🔥 todo listo, finalizada",
    pt: "Apple Inc — 🔥 tudo pronto, finalizado",
    de: "Apple Inc — 🔥 alles erledigt",
    fr: "Apple Inc — 🔥 tout est terminé",
  },
  inviteHook54: {
    ru: "Apple Inc, 🔥 сделка закрыта через 2 Месяца",
    en: "Apple Inc, 🔥 trade closed after 2 Months",
    es: "Apple Inc, 🔥 cerrada después de 2 Meses",
    pt: "Apple Inc, 🔥 encerrada após 2 Meses",
    de: "Apple Inc, 🔥 abgeschlossen nach 2 Monaten",
    fr: "Apple Inc, 🔥 clôturé après 2 Mois",
  },
  inviteHook55: {
    ru: "Позиция завершена 🔥 — Apple Inc",
    en: "Finished position 🔥 — Apple Inc",
    es: "Posición finalizada 🔥 — Apple Inc",
    pt: "Posição concluída 🔥 — Apple Inc",
    de: "Position fertig 🔥 — Apple Inc",
    fr: "Position finie 🔥 — Apple Inc",
  },
  inviteHook56: {
    ru: "Apple Inc — 🔥 финальный шаг завершён",
    en: "Apple Inc — 🔥 last step complete",
    es: "Apple Inc — 🔥 último paso completado",
    pt: "Apple Inc — 🔥 último passo completo",
    de: "Apple Inc — 🔥 letzter Schritt abgeschlossen",
    fr: "Apple Inc — 🔥 dernière étape bouclée",
  },
  inviteHook57: {
    ru: "Сделка 🔥 по Apple Inc закрыта",
    en: "Done 🔥 with Apple Inc trade",
    es: "Operación 🔥 finalizada en Apple Inc",
    pt: "Concluído 🔥 o trade em Apple Inc",
    de: "Trade 🔥 erledigt bei Apple Inc",
    fr: "Fini 🔥 avec Apple Inc",
  },
  inviteHook58: {
    ru: "Apple Inc — 🔥 аккуратное завершение",
    en: "Apple Inc — 🔥 wrapped it right",
    es: "Apple Inc — 🔥 cierre preciso",
    pt: "Apple Inc — 🔥 fechamento certo",
    de: "Apple Inc — 🔥 sauber beendet",
    fr: "Apple Inc — 🔥 clôturé proprement",
  },
  inviteHook59: {
    ru: "Сделка завершена 🔥 через 2 Месяца — Apple Inc",
    en: "Trade done 🔥 after 2 Months — Apple Inc",
    es: "Operación terminada 🔥 después de 2 Meses — Apple Inc",
    pt: "Trade concluído 🔥 após 2 Meses — Apple Inc",
    de: "Trade beendet 🔥 nach 2 Monaten — Apple Inc",
    fr: "Trade terminé 🔥 après 2 Mois — Apple Inc",
  },
  inviteHook60: {
    ru: "Apple Inc — 🔥 чистое закрытие",
    en: "Apple Inc — 🔥 clear wrap-up",
    es: "Apple Inc — 🔥 cierre limpio",
    pt: "Apple Inc — 🔥 fechamento limpo",
    de: "Apple Inc — 🔥 sauberer Abschluss",
    fr: "Apple Inc — 🔥 clôture claire",
  },
  inviteHook61: {
    ru: "Сделка закрыта аккуратно 🔥 — Apple Inc",
    en: "Trade closed neatly 🔥 — Apple Inc",
    es: "Cierre perfecto 🔥 — Apple Inc",
    pt: "Fechamento completo 🔥 — Apple Inc",
    de: "Sauber beendet 🔥 — Apple Inc",
    fr: "Clôturé proprement 🔥 — Apple Inc",
  },
  inviteHook62: {
    ru: "Apple Inc — 🔥 движение завершено",
    en: "Apple Inc — 🔥 move completed",
    es: "Apple Inc — 🔥 movimiento completado",
    pt: "Apple Inc — 🔥 movimento encerrado",
    de: "Apple Inc — 🔥 Bewegung abgeschlossen",
    fr: "Apple Inc — 🔥 mouvement terminé",
  },
  inviteHook63: {
    ru: "Apple Inc, 🔥 сделка завершена через 2 Месяца",
    en: "Apple Inc, 🔥 trade done after 2 Months",
    es: "Apple Inc, 🔥 operación finalizada después de 2 Meses",
    pt: "Apple Inc, 🔥 trade concluído após 2 Meses",
    de: "Apple Inc, 🔥 beendet nach 2 Monaten",
    fr: "Apple Inc, 🔥 clôturé après 2 Mois",
  },
  inviteHook64: {
    ru: "Позиция завершена 🔥 — Apple Inc",
    en: "Position completed 🔥 — Apple Inc",
    es: "Posición completada 🔥 — Apple Inc",
    pt: "Posição concluída 🔥 — Apple Inc",
    de: "Position beendet 🔥 — Apple Inc",
    fr: "Position complétée 🔥 — Apple Inc",
  },
  inviteHook65: {
    ru: "Apple Inc — 🔥 цикл завершён",
    en: "Apple Inc — 🔥 cycle closed",
    es: "Apple Inc — 🔥 ciclo cerrado",
    pt: "Apple Inc — 🔥 ciclo encerrado",
    de: "Apple Inc — 🔥 Zyklus abgeschlossen",
    fr: "Apple Inc — 🔥 cycle terminé",
  },
  inviteHook66: {
    ru: "Завершено чисто 🔥 — Apple Inc",
    en: "Wrapped clean 🔥 — Apple Inc",
    es: "Cerrado limpio 🔥 — Apple Inc",
    pt: "Fechado limpo 🔥 — Apple Inc",
    de: "Sauber geschlossen 🔥 — Apple Inc",
    fr: "Fermé proprement 🔥 — Apple Inc",
  },
  inviteHook67: {
    ru: "Apple Inc, 🔥 сделка завершена спустя 2 Месяца",
    en: "Apple Inc, 🔥 trade done after 2 Months",
    es: "Apple Inc, 🔥 operación finalizada después de 2 Meses",
    pt: "Apple Inc, 🔥 trade finalizado após 2 Meses",
    de: "Apple Inc, 🔥 abgeschlossen nach 2 Monaten",
    fr: "Apple Inc, 🔥 trade terminé après 2 Mois",
  },
  inviteHook68: {
    ru: "Apple Inc — 🔥 финальное завершение",
    en: "Apple Inc — 🔥 final wrap complete",
    es: "Apple Inc — 🔥 cierre final",
    pt: "Apple Inc — 🔥 fechamento final",
    de: "Apple Inc — 🔥 letzter Abschluss",
    fr: "Apple Inc — 🔥 clôture finale",
  },
  inviteHook69: {
    ru: "Закрыл сделку 🔥 по Apple Inc",
    en: "Closed the trade 🔥 on Apple Inc",
    es: "Cerré la operación 🔥 en Apple Inc",
    pt: "Fechei a operação 🔥 em Apple Inc",
    de: "Trade 🔥 bei Apple Inc geschlossen",
    fr: "Trade 🔥 clôturé sur Apple Inc",
  },
  inviteHook70: {
    ru: "Apple Inc — 🔥 стабильное завершение",
    en: "Apple Inc — 🔥 finished solid",
    es: "Apple Inc — 🔥 cierre sólido",
    pt: "Apple Inc — 🔥 fechamento sólido",
    de: "Apple Inc — 🔥 stabil beendet",
    fr: "Apple Inc — 🔥 fin solide",
  },
  inviteHook71: {
    ru: "Сделка завершена 🔥 по Apple Inc",
    en: "Trade done 🔥 on Apple Inc",
    es: "Operación hecha 🔥 en Apple Inc",
    pt: "Trade concluído 🔥 em Apple Inc",
    de: "Trade beendet 🔥 bei Apple Inc",
    fr: "Trade terminé 🔥 sur Apple Inc",
  },
  inviteHook72: {
    ru: "Apple Inc — 🔥 чистое завершение",
    en: "Apple Inc — 🔥 clean closure",
    es: "Apple Inc — 🔥 cierre limpio",
    pt: "Apple Inc — 🔥 fechamento limpo",
    de: "Apple Inc — 🔥 sauber abgeschlossen",
    fr: "Apple Inc — 🔥 clôture propre",
  },
  inviteHook73: {
    ru: "Сделка завершена 🔥 через 2 Месяца — Apple Inc",
    en: "Trade done 🔥 after 2 Months — Apple Inc",
    es: "Operación completada 🔥 tras 2 Meses — Apple Inc",
    pt: "Trade concluído 🔥 após 2 Meses — Apple Inc",
    de: "Trade beendet 🔥 nach 2 Monaten — Apple Inc",
    fr: "Trade terminé 🔥 après 2 Mois — Apple Inc",
  },
  inviteHook74: {
    ru: "Apple Inc — 🔥 полный цикл завершён",
    en: "Apple Inc — 🔥 full cycle completed",
    es: "Apple Inc — 🔥 ciclo completo",
    pt: "Apple Inc — 🔥 ciclo completo",
    de: "Apple Inc — 🔥 Zyklus komplett",
    fr: "Apple Inc — 🔥 cycle complet",
  },
  inviteHook75: {
    ru: "Чистое закрытие 🔥 по Apple Inc",
    en: "Clean close 🔥 on Apple Inc",
    es: "Cierre limpio 🔥 en Apple Inc",
    pt: "Fechamento limpo 🔥 em Apple Inc",
    de: "Sauber geschlossen 🔥 bei Apple Inc",
    fr: "Clôture propre 🔥 sur Apple Inc",
  },
  inviteHook76: {
    ru: "Apple Inc 🔥 закрыта ровно",
    en: "Apple Inc 🔥 wrapped well",
    es: "Apple Inc 🔥 cerrada bien",
    pt: "Apple Inc 🔥 fechada bem",
    de: "Apple Inc 🔥 gut beendet",
    fr: "Apple Inc 🔥 bien bouclé",
  },
  inviteHook77: {
    ru: "Позиция завершена 🔥 — Apple Inc",
    en: "Position completed 🔥 — Apple Inc",
    es: "Posición completada 🔥 — Apple Inc",
    pt: "Posição concluída 🔥 — Apple Inc",
    de: "Position abgeschlossen 🔥 — Apple Inc",
    fr: "Position complétée 🔥 — Apple Inc",
  },
  inviteHook78: {
    ru: "Apple Inc — 🔥 закрыта и завершена",
    en: "Apple Inc — 🔥 closed and done",
    es: "Apple Inc — 🔥 cerrada y lista",
    pt: "Apple Inc — 🔥 encerrada e concluída",
    de: "Apple Inc — 🔥 geschlossen und fertig",
    fr: "Apple Inc — 🔥 fermé et terminé",
  },
  inviteHook79: {
    ru: "Закрыл ещё один цикл 🔥 — Apple Inc",
    en: "Closed another cycle 🔥 — Apple Inc",
    es: "Otro ciclo cerrado 🔥 — Apple Inc",
    pt: "Outro ciclo encerrado 🔥 — Apple Inc",
    de: "Nächster Zyklus beendet 🔥 — Apple Inc",
    fr: "Nouveau cycle clôturé 🔥 — Apple Inc",
  },
  inviteHook80: {
    ru: "Apple Inc — 🔥 сделка чисто завершена",
    en: "Apple Inc — 🔥 trade wrapped clearly",
    es: "Apple Inc — 🔥 operación cerrada con claridad",
    pt: "Apple Inc — 🔥 trade encerrado com clareza",
    de: "Apple Inc — 🔥 Trade klar beendet",
    fr: "Apple Inc — 🔥 trade clairement bouclé",
  },
  inviteHook81: {
    ru: "Закрыл ещё один цикл 🔥 — Apple Inc",
    en: "Closed another cycle 🔥 — Apple Inc",
    es: "Otro ciclo cerrado 🔥 — Apple Inc",
    pt: "Outro ciclo finalizado 🔥 — Apple Inc",
    de: "Nächster Zyklus abgeschlossen 🔥 — Apple Inc",
    fr: "Nouveau cycle terminé 🔥 — Apple Inc",
  },
  inviteHook82: {
    ru: "Apple Inc — 🔥 простое завершение",
    en: "Apple Inc — 🔥 simple wrap",
    es: "Apple Inc — 🔥 cierre simple",
    pt: "Apple Inc — 🔥 fechamento simples",
    de: "Apple Inc — 🔥 einfacher Abschluss",
    fr: "Apple Inc — 🔥 clôture simple",
  },
  inviteHook83: {
    ru: "Сделка завершена корректно 🔥 — Apple Inc",
    en: "Trade done right 🔥 — Apple Inc",
    es: "Operación hecha bien 🔥 — Apple Inc",
    pt: "Trade bem feito 🔥 — Apple Inc",
    de: "Trade gut gemacht 🔥 — Apple Inc",
    fr: "Trade bien fait 🔥 — Apple Inc",
  },
  inviteHook84: {
    ru: "Apple Inc — 🔥 ещё одно чистое завершение",
    en: "Apple Inc — 🔥 one more clean exit",
    es: "Apple Inc — 🔥 otro cierre limpio",
    pt: "Apple Inc — 🔥 outro fechamento limpo",
    de: "Apple Inc — 🔥 weiterer sauberer Exit",
    fr: "Apple Inc — 🔥 encore une sortie propre",
  },
  inviteHook85: {
    ru: "Завершена сделка 🔥 по Apple Inc",
    en: "Finished 🔥 Apple Inc — clean result",
    es: "Operación completada 🔥 en Apple Inc",
    pt: "Trade finalizado 🔥 em Apple Inc",
    de: "Abgeschlossen 🔥 bei Apple Inc",
    fr: "Terminé 🔥 avec Apple Inc",
  },
  inviteHook86: {
    ru: "Apple Inc — 🔥 сделка закрыта через 2 Месяца",
    en: "Apple Inc — 🔥 trade closed after 2 Months",
    es: "Apple Inc — 🔥 operación cerrada tras 2 Meses",
    pt: "Apple Inc — 🔥 trade fechado após 2 Meses",
    de: "Apple Inc — 🔥 Trade beendet nach 2 Monaten",
    fr: "Apple Inc — 🔥 trade clôturé après 2 Mois",
  },
  inviteHook87: {
    ru: "Apple Inc 🔥 завершил этот раунд",
    en: "Apple Inc 🔥 wrapped up this round",
    es: "Apple Inc 🔥 cerró esta ronda",
    pt: "Apple Inc 🔥 encerrou esta rodada",
    de: "Apple Inc 🔥 abgeschlossen in dieser Runde",
    fr: "Apple Inc 🔥 bouclé cette fois",
  },
  inviteHook88: {
    ru: "Позиция зафиксирована — 🔥 Apple Inc",
    en: "Position locked — 🔥 Apple Inc",
    es: "Posición bloqueada — 🔥 Apple Inc",
    pt: "Posição travada — 🔥 Apple Inc",
    de: "Position gesichert — 🔥 Apple Inc",
    fr: "Position sécurisée — 🔥 Apple Inc",
  },
  inviteHook89: {
    ru: "Apple Inc — 🔥 стабильное завершение",
    en: "Apple Inc — 🔥 steady close",
    es: "Apple Inc — 🔥 cierre estable",
    pt: "Apple Inc — 🔥 fechamento estável",
    de: "Apple Inc — 🔥 stabil beendet",
    fr: "Apple Inc — 🔥 clôture stable",
  },
  inviteHook90: {
    ru: "Сделка 🔥 по Apple Inc завершена",
    en: "Done 🔥 with Apple Inc",
    es: "Operación 🔥 completada en Apple Inc",
    pt: "Trade 🔥 concluído em Apple Inc",
    de: "Trade 🔥 erledigt mit Apple Inc",
    fr: "Terminé 🔥 avec Apple Inc",
  },
  inviteHook91: {
    ru: "Apple Inc — 🔥 позиция финализирована",
    en: "Apple Inc — 🔥 position finalized",
    es: "Apple Inc — 🔥 posición finalizada",
    pt: "Apple Inc — 🔥 posição finalizada",
    de: "Apple Inc — 🔥 Position finalisiert",
    fr: "Apple Inc — 🔥 position finalisée",
  },
  inviteHook92: {
    ru: "Сделка завершена 🔥 — Apple Inc, плавное закрытие",
    en: "Trade over 🔥 — Apple Inc, smooth wrap",
    es: "Operación finalizada 🔥 — Apple Inc, cierre suave",
    pt: "Trade encerrado 🔥 — Apple Inc, fechamento suave",
    de: "Trade vorbei 🔥 — Apple Inc, sauber abgeschlossen",
    fr: "Trade fini 🔥 — Apple Inc, clôture fluide",
  },
  inviteHook93: {
    ru: "Apple Inc — 🔥 позиция закрыта полностью",
    en: "Apple Inc — 🔥 position clear and done",
    es: "Apple Inc — 🔥 posición cerrada completamente",
    pt: "Apple Inc — 🔥 posição encerrada e limpa",
    de: "Apple Inc — 🔥 Position beendet und klar",
    fr: "Apple Inc — 🔥 position claire et terminée",
  },
  inviteHook94: {
    ru: "Apple Inc 🔥 закрыта — сделка завершена",
    en: "Apple Inc 🔥 closed — trade complete",
    es: "Apple Inc 🔥 cerrada — operación lista",
    pt: "Apple Inc 🔥 fechada — trade completo",
    de: "Apple Inc 🔥 geschlossen — Trade komplett",
    fr: "Apple Inc 🔥 clôturé — trade complet",
  },
  inviteHook95: {
    ru: "Сделка закрыта 🔥 через 2 Месяца — Apple Inc",
    en: "Trade closed 🔥 after 2 Months — Apple Inc",
    es: "Operación cerrada 🔥 tras 2 Meses — Apple Inc",
    pt: "Trade fechado 🔥 após 2 Meses — Apple Inc",
    de: "Trade beendet 🔥 nach 2 Monaten — Apple Inc",
    fr: "Trade terminé 🔥 après 2 Mois — Apple Inc",
  },
  inviteHook96: {
    ru: "Apple Inc — 🔥 сделка завершена чисто",
    en: "Apple Inc — 🔥 trade wrapped clean",
    es: "Apple Inc — 🔥 operación limpia",
    pt: "Apple Inc — 🔥 trade encerrado limpo",
    de: "Apple Inc — 🔥 Trade sauber beendet",
    fr: "Apple Inc — 🔥 trade proprement clôturé",
  },
  inviteHook97: {
    ru: "Завершена позиция 🔥 по Apple Inc",
    en: "Wrapped up 🔥 Apple Inc position",
    es: "Posición cerrada 🔥 en Apple Inc",
    pt: "Posição encerrada 🔥 em Apple Inc",
    de: "Position abgeschlossen 🔥 bei Apple Inc",
    fr: "Position bouclée 🔥 — Apple Inc",
  },
  inviteHook98: {
    ru: "Apple Inc — 🔥 позиция закрыта",
    en: "Apple Inc — 🔥 position wrapped",
    es: "Apple Inc — 🔥 posición cerrada",
    pt: "Apple Inc — 🔥 posição encerrada",
    de: "Apple Inc — 🔥 Position beendet",
    fr: "Apple Inc — 🔥 position terminée",
  },
  inviteHook99: {
    ru: "Apple Inc, 🔥 цикл завершён спустя 2 Месяца",
    en: "Apple Inc, 🔥 cycle complete after 2 Months",
    es: "Apple Inc, 🔥 ciclo completado tras 2 Meses",
    pt: "Apple Inc, 🔥 ciclo concluído após 2 Meses",
    de: "Apple Inc, 🔥 Zyklus abgeschlossen nach 2 Monaten",
    fr: "Apple Inc, 🔥 cycle terminé après 2 Mois",
  },
  inviteHook100: {
    ru: "Apple Inc — 🔥 чистое завершение, всё готово",
    en: "Apple Inc — 🔥 clean finish, all done",
    es: "Apple Inc — 🔥 cierre limpio, todo hecho",
    pt: "Apple Inc — 🔥 fechamento limpo, tudo pronto",
    de: "Apple Inc — 🔥 sauber beendet, alles erledigt",
    fr: "Apple Inc — 🔥 fin propre, tout est fait",
  },
  inviteHookSecondTitle1: {
    ru: "Так всё прошло — посмотрим, что даст рынок дальше",
    en: "That’s how it went — let’s see what the market brings next",
    es: "Así fue todo — veamos qué trae el mercado después",
    pt: "Foi assim que tudo aconteceu — vamos ver o que o mercado traz a seguir",
    de: "So lief alles ab – mal sehen, was der Markt als Nächstes bringt",
    fr: "Voilà comment tout s’est passé — voyons ce que le marché nous réserve ensuite",
  },
  inviteHookSecondTitle2: {
    ru: "Сделка завершена, но впереди новые истории",
    en: "The trade’s done, but more stories are ahead",
    es: "Operación cerrada, pero vienen nuevas historias",
    pt: "Operação encerrada, mas novas histórias já estão a caminho",
    de: "Trade abgeschlossen, aber neue Geschichten stehen schon bevor",
    fr: "Trade terminé, mais de nouvelles histoires commencent déjà",
  },
  inviteHookSecondTitle3: {
    ru: "Финал этого цикла — начало следующего",
    en: "The end of this cycle — the start of the next one",
    es: "El final de este ciclo — el inicio del siguiente",
    pt: "O fim deste ciclo — o início do próximo",
    de: "Das Ende dieses Zyklus – der Beginn des nächsten",
    fr: "La fin de ce cycle — le début du suivant",
  },
  inviteHookSecondTitle4: {
    ru: "Всё по плану. Следующий сетап уже формируется",
    en: "All went by the plan. The next setup is already forming",
    es: "Todo salió según el plan. El próximo setup ya se está formando",
    pt: "Tudo saiu conforme o plano. O próximo setup já está se formando",
    de: "Alles lief nach Plan. Das nächste Setup formt sich bereits",
    fr: "Tout s’est déroulé comme prévu. Le prochain setup se met déjà en place",
  },
  inviteHookSecondTitle5: {
    ru: "Так выглядел процесс. Скоро новое движение",
    en: "Here’s how the process looked. A new move is coming soon",
    es: "Así se vio el proceso. Pronto llega un nuevo movimiento",
    pt: "Assim foi o processo. Em breve, um novo movimento",
    de: "So sah der Prozess aus. Bald kommt die nächste Bewegung",
    fr: "Voici le déroulement. Bientôt, un nouveau mouvement",
  },
  inviteHookSecondTitle6: {
    ru: "Всё сложилось, как нужно. Жду следующей возможности",
    en: "Everything played out right. Waiting for the next opportunity",
    es: "Todo salió bien. Esperando la próxima oportunidad",
    pt: "Tudo correu bem. Agora espero a próxima oportunidade",
    de: "Alles hat sich gefügt. Jetzt warte ich auf die nächste Gelegenheit",
    fr: "Tout s’est aligné parfaitement. J’attends maintenant la prochaine opportunité",
  },
  inviteHookSecondTitle7: {
    ru: "Цикл закрыт, но рынок не останавливается",
    en: "Cycle closed, but the market never stops",
    es: "Ciclo cerrado, pero el mercado nunca se detiene",
    pt: "Ciclo fechado, mas o mercado nunca para",
    de: "Zyklus beendet, aber der Markt bleibt in Bewegung",
    fr: "Cycle clos, mais le marché ne s’arrête jamais",
  },
  inviteHookSecondTitle8: {
    ru: "Сделка завершена — и снова ждем новую возможность",
    en: "Trade complete — waiting again for the next setup",
    es: "Operación completa — esperando otra oportunidad",
    pt: "Operação concluída — aguardando a próxima oportunidade",
    de: "Trade abgeschlossen – auf die nächste Chance warten wir schon",
    fr: "Trade clôturé — on attend déjà la prochaine opportunité",
  },
  inviteHookSecondTitle9: {
    ru: "История этой позиции закончена, но продолжение следует",
    en: "This position’s story is done, but the continuation’s coming",
    es: "La historia de esta posición terminó, pero sigue la secuencia",
    pt: "A história desta posição terminou, mas a sequência continua",
    de: "Die Geschichte dieser Position ist vorbei, aber es geht weiter",
    fr: "L’histoire de cette position est terminée, mais la suite arrive",
  },
  inviteHookSecondTitle10: {
    ru: "Так всё было — и теперь время ждать следующего шага",
    en: "That’s how it was — now time to wait for the next step",
    es: "Así fue todo — ahora toca esperar el siguiente paso",
    pt: "Foi assim — agora é hora de esperar o próximo passo",
    de: "So war es – jetzt heißt es, auf den nächsten Schritt warten",
    fr: "Voilà comment tout s’est déroulé — maintenant, place au prochain mouvement",
  },
  inviteHookSecondTitle11: {
    ru: "Следующий сетап уже на радарах",
    en: "The next setup is already on the radar",
    es: "El próximo setup ya está en el radar",
    pt: "O próximo setup já está no radar",
    de: "Das nächste Setup ist bereits auf dem Radar",
    fr: "Le prochain setup est déjà sur le radar",
  },
  inviteHookSecondTitle12: {
    ru: "Этот цикл завершён, новый — уже близко",
    en: "This cycle’s finished, the next one’s close",
    es: "Este ciclo terminó, el siguiente está cerca",
    pt: "Este ciclo terminou, o próximo já está próximo",
    de: "Dieser Zyklus ist beendet, der nächste steht kurz bevor",
    fr: "Ce cycle est terminé, le prochain est tout proche",
  },
  inviteHookSecondTitle13: {
    ru: "Рынок не спит, значит, впереди новые возможности",
    en: "The market doesn’t sleep — new chances ahead",
    es: "El mercado no duerme — nuevas oportunidades por venir",
    pt: "O mercado não dorme — novas oportunidades estão por vir",
    de: "Der Markt schläft nie – neue Chancen sind unterwegs",
    fr: "Le marché ne dort jamais — de nouvelles opportunités arrivent",
  },
  inviteHookSecondTitle14: {
    ru: "Финал есть, но история продолжается",
    en: "The finish is here, but the story goes on",
    es: "Hay un final, pero la historia continúa",
    pt: "Há um final, mas a história continua",
    de: "Ein Abschluss, aber die Geschichte geht weiter",
    fr: "Une fin, mais l’histoire continue",
  },
  inviteHookSecondTitle15: {
    ru: "Так всё было — посмотрим, как пойдёт дальше",
    en: "That’s how it went — let’s see what comes next",
    es: "Así fue — veremos qué sigue",
    pt: "Assim foi — veremos o que vem a seguir",
    de: "So war’s – mal sehen, wie es weitergeht",
    fr: "Voilà comment tout s’est passé — voyons la suite",
  },
  inviteHookSecondTitle16: {
    ru: "Теперь внимание на следующий график",
    en: "Now shifting focus to the next chart",
    es: "Ahora el enfoque está en el siguiente gráfico",
    pt: "Agora o foco está no próximo gráfico",
    de: "Jetzt liegt der Fokus auf dem nächsten Chart",
    fr: "Maintenant, focus sur le prochain graphique",
  },
  inviteHookSecondTitle17: {
    ru: "Сделка закрыта, фокус — на новых паттернах",
    en: "Trade closed, focus now on new patterns",
    es: "Operación cerrada, enfoque ahora en nuevos patrones",
    pt: "Operação encerrada, foco agora em novos padrões",
    de: "Trade beendet, Fokus jetzt auf neue Muster",
    fr: "Trade clôturé, concentration sur de nouveaux schémas",
  },
  inviteHookSecondTitle18: {
    ru: "После этого цикла — свежий анализ и новые планы",
    en: "After this cycle — fresh analysis and new plans",
    es: "Después de este ciclo — nuevo análisis y nuevos planes",
    pt: "Depois deste ciclo — nova análise e novos planos",
    de: "Nach diesem Zyklus – frische Analyse und neue Pläne",
    fr: "Après ce cycle — nouvelle analyse et nouveaux plans",
  },
  inviteHookSecondTitle19: {
    ru: "Рынок дал результат, теперь жду новый шанс",
    en: "Market delivered — now waiting for the next shot",
    es: "El mercado cumplió — ahora espero la próxima jugada",
    pt: "O mercado entregou — agora espero a próxima jogada",
    de: "Der Markt hat geliefert, jetzt warte ich auf die nächste Gelegenheit",
    fr: "Le marché a réagi, maintenant j’attends la prochaine opportunité",
  },
  inviteHookSecondTitle20: {
    ru: "Один сценарий завершён, следующий — на подходе",
    en: "One scenario closed, the next one’s on its way",
    es: "Un escenario termina, el siguiente ya se acerca",
    pt: "Um cenário termina, o próximo já se aproxima",
    de: "Ein Szenario endet, das nächste steht bereit",
    fr: "Un scénario se termine, le suivant se prépare",
  },
  inviteHookSecondTitle21: {
    ru: "График прожил свой ритм — чисто и спокойно",
    en: "The chart lived its rhythm — smooth and calm",
    es: "El gráfico vivió su ritmo — fluido y tranquilo",
    pt: "O gráfico viveu o seu ritmo — limpo e tranquilo",
    de: "Der Chart hat seinen Rhythmus gelebt – klar und ruhig",
    fr: "Le graphique a vécu son rythme — clair et calme",
  },
  inviteHookSecondTitle22: {
    ru: "Прошел уверенно от начала до конца",
    en: "Went steady from start to finish",
    es: "De inicio a fin, todo fue estable",
    pt: "Do início ao fim, tudo foi estável",
    de: "Von Anfang bis Ende – alles lief stabil",
    fr: "Du début à la fin — tout s’est déroulé avec stabilité",
  },
  inviteHookSecondTitle23: {
    ru: "Сделка прошла мягко, без лишнего шума",
    en: "Trade went softly, without noise",
    es: "Operación suave, sin ruido extra",
    pt: "Operação suave, sem ruído desnecessário",
    de: "Trade glatt gelaufen, ohne unnötigen Lärm",
    fr: "Trade fluide, sans bruit inutile",
  },
  inviteHookSecondTitle24: {
    ru: "Атмосфера сделки — ровная и ясная",
    en: "The atmosphere of the trade — clear and balanced",
    es: "La atmósfera del trade — clara y equilibrada",
    pt: "A atmosfera do trade — clara e equilibrada",
    de: "Die Atmosphäre des Trades – klar und ausgeglichen",
    fr: "L’ambiance du trade — claire et équilibrée",
  },
  inviteHookSecondTitle25: {
    ru: "Чувствуется завершённость, как в выдохе после марафона",
    en: "Feels complete, like an exhale after a marathon",
    es: "Se siente la conclusión, como un respiro después del maratón",
    pt: "Sente-se a conclusão, como um suspiro após uma maratona",
    de: "Man spürt den Abschluss – wie ein Ausatmen nach einem Marathon",
    fr: "On sent la fin — comme un souffle après un marathon",
  },
  inviteHookSecondTitle26: {
    ru: "Всё выглядело гармонично, без перегрузок",
    en: "Everything looked harmonious, no overloads",
    es: "Todo se vio armonioso, sin sobrecarga",
    pt: "Tudo pareceu harmonioso, sem exageros",
    de: "Alles wirkte harmonisch, ohne Übertreibung",
    fr: "Tout paraissait harmonieux, sans excès",
  },
  inviteHookSecondTitle27: {
    ru: "Рынок отработал, как по рельсам",
    en: "Market moved like on rails",
    es: "El mercado se movió como sobre rieles",
    pt: "O mercado se moveu como sobre trilhos",
    de: "Der Markt lief wie auf Schienen",
    fr: "Le marché a évolué comme sur des rails",
  },
  inviteHookSecondTitle28: {
    ru: "Каждая свеча ощущалась в ритме процесса",
    en: "Each candle felt in sync with the rhythm",
    es: "Cada vela siguió el ritmo del proceso",
    pt: "Cada candle seguiu o ritmo do processo",
    de: "Jede Kerze im Rhythmus des Prozesses",
    fr: "Chaque bougie suivait le rythme du processus",
  },
  inviteHookSecondTitle29: {
    ru: "Финал лёгкий, прозрачный, без давления",
    en: "Light, transparent finish — no pressure",
    es: "Final ligero y claro — sin presión",
    pt: "Final leve e transparente — sem pressão",
    de: "Leichtes, sauberes Ende – ohne Druck",
    fr: "Une fin légère et propre — sans pression",
  },
  inviteHookSecondTitle30: {
    ru: "Картина движения - чистая",
    en: "The price action looked clean",
    es: "El movimiento se vio limpio",
    pt: "O movimento pareceu limpo",
    de: "Die Marktbewegung war klar und sauber",
    fr: "Le mouvement du marché était net et fluide",
  },
  inviteHookSecondTitle31: {
    ru: "От ожидания к результату — всё по ритму",
    en: "From anticipation to result — all in rhythm",
    es: "De la espera al resultado — todo en su ritmo",
    pt: "Da espera ao resultado — tudo no ritmo certo",
    de: "Von der Erwartung bis zum Ergebnis – alles im Rhythmus",
    fr: "De l’attente au résultat — tout dans le bon rythme",
  },
  inviteHookSecondTitle32: {
    ru: "Сначала напряжение, потом чистое завершение",
    en: "Tension first, then a clean close",
    es: "Primero tensión, luego cierre limpio",
    pt: "Primeiro a tensão, depois um fechamento limpo",
    de: "Erst Spannung, dann ein sauberer Abschluss",
    fr: "D’abord la tension, puis une clôture claire",
  },
  inviteHookSecondTitle33: {
    ru: "Всё идёт своим чередом — новое впереди",
    en: "Everything flows as usual — new things ahead",
    es: "Todo fluye como siempre — lo nuevo viene en camino",
    pt: "Tudo segue seu curso — o novo está chegando",
    de: "Alles läuft seinen gewohnten Lauf – Neues kommt",
    fr: "Tout suit son cours — un nouveau cycle arrive",
  },
  inviteHookSecondTitle34: {
    ru: "Ещё один спокойный финал, как по нотам",
    en: "Another calm ending, note for note",
    es: "Otro cierre tranquilo, todo en su tono",
    pt: "Mais um fechamento tranquilo, tudo em sintonia",
    de: "Wieder ein ruhiger Abschluss – alles im Einklang",
    fr: "Encore une fin calme, tout en harmonie",
  },
  inviteHookSecondTitle35: {
    ru: "Всё прошло динамично и спокойно в финале",
    en: "All moved dynamically, yet calmly at the end",
    es: "Todo fue dinámico y tranquilo al final",
    pt: "Tudo foi dinâmico e sereno no final",
    de: "Alles verlief dynamisch, aber ruhig im Finale",
    fr: "Tout s’est déroulé de façon dynamique mais sereine",
  },
  inviteHookSecondTitle36: {
    ru: "Всё по привычному сценарию",
    en: "Everything followed the usual scenario",
    es: "Todo siguió el escenario habitual",
    pt: "Tudo seguiu o roteiro habitual",
    de: "Alles nach gewohntem Muster",
    fr: "Tout selon le scénario habituel",
  },
  inviteHookSecondTitle37: {
    ru: "День закончился точно по схеме",
    en: "Day ended exactly by the plan",
    es: "El día terminó justo según el plan",
    pt: "O dia terminou exatamente conforme o plano",
    de: "Der Tag endete genau nach Plan",
    fr: "La journée s’est terminée exactement selon le plan",
  },
  inviteHookSecondTitle38: {
    ru: "Рынок выдохнул, и я вместе с ним",
    en: "Market exhaled — and so did I",
    es: "El mercado exhaló — y yo con él",
    pt: "O mercado expirou — e eu junto com ele",
    de: "Der Markt atmete aus – und ich mit ihm",
    fr: "Le marché a soufflé — et moi avec lui",
  },
  inviteHookSecondTitle39: {
    ru: "Сетап прожил себя полностью",
    en: "Setup lived itself fully",
    es: "El setup se cumplió por completo",
    pt: "O setup se completou por inteiro",
    de: "Das Setup hat sich vollständig entfaltet",
    fr: "Le setup s’est pleinement développé",
  },
  inviteHookSecondTitle40: {
    ru: "Контраст между стартом и финалом — идеальный баланс",
    en: "Perfect balance between start and finish",
    es: "Equilibrio perfecto entre inicio y final",
    pt: "Equilíbrio perfeito entre o início e o fim",
    de: "Perfekte Balance zwischen Start und Abschluss",
    fr: "Équilibre parfait entre le début et la fin",
  },
  inviteHookSecondTitle41: {
    ru: "Всё по плану: вход, движение, результат",
    en: "All by plan: entry, move, result",
    es: "Todo según el plan: entrada, movimiento, resultado",
    pt: "Tudo conforme o plano: entrada, movimento, resultado",
    de: "Alles nach Plan: Einstieg, Bewegung, Ergebnis",
    fr: "Tout selon le plan : entrée, mouvement, résultat",
  },
  inviteHookSecondTitle42: {
    ru: "Рынок подтвердил систему — спокойно, без эмоций",
    en: "Market confirmed the system — calm and steady",
    es: "El mercado confirmó el sistema — sereno y firme",
    pt: "O mercado confirmou o sistema — sereno e firme",
    de: "Der Markt hat das System bestätigt – ruhig und klar",
    fr: "Le marché a validé le système — calme et précis",
  },
  inviteHookSecondTitle43: {
    ru: "Сделка завершена чётко, как и задумано",
    en: "Trade closed cleanly, just as intended",
    es: "Operación cerrada con limpieza, como estaba previsto",
    pt: "Operação encerrada com clareza, como previsto",
    de: "Trade abgeschlossen – sauber und wie vorgesehen",
    fr: "Trade clôturé — propre et conforme au plan",
  },
  inviteHookSecondTitle44: {
    ru: "Всё прошло предсказуемо, без сюрпризов",
    en: "Everything unfolded predictably, no surprises",
    es: "Todo fue predecible, sin sorpresas",
    pt: "Tudo foi previsível, sem surpresas",
    de: "Alles verlief vorhersehbar, ohne Überraschungen",
    fr: "Tout était prévisible, sans surprises",
  },
  inviteHookSecondTitle45: {
    ru: "Дисциплина снова доказала силу",
    en: "Discipline proved its strength again",
    es: "La disciplina volvió a demostrar su fuerza",
    pt: "A disciplina mostrou sua força mais uma vez",
    de: "Disziplin hat wieder ihre Stärke gezeigt",
    fr: "La discipline a encore prouvé sa force",
  },
  inviteHookSecondTitle46: {
    ru: "Сценарий сработал, контроль сохранён",
    en: "Scenario worked — control maintained",
    es: "El escenario funcionó — control mantenido",
    pt: "O cenário funcionou — controle mantido",
    de: "Das Szenario funktionierte – Kontrolle beibehalten",
    fr: "Le scénario a fonctionné — contrôle maintenu",
  },
  inviteHookSecondTitle47: {
    ru: "Без спешки, без азарта — просто метод",
    en: "No rush, no thrill — just the method",
    es: "Sin prisa, sin impulso — solo método",
    pt: "Sem pressa, sem impulso — apenas método",
    de: "Kein Stress, keine Eile – nur Methode",
    fr: "Pas de précipitation, pas d’impulsion — juste la méthode",
  },
  inviteHookSecondTitle48: {
    ru: "Ещё один пример устойчивой стратегии",
    en: "Another example of a steady strategy",
    es: "Otro ejemplo de estrategia constante",
    pt: "Mais um exemplo de estratégia consistente",
    de: "Ein weiteres Beispiel für eine stabile Strategie",
    fr: "Encore un exemple de stratégie solide",
  },
  inviteHookSecondTitle49: {
    ru: "Всё в рамках системы, всё логично",
    en: "All within the system, all logical",
    es: "Todo dentro del sistema, todo lógico",
    pt: "Tudo dentro do sistema, tudo lógico",
    de: "Alles im Rahmen des Systems, alles logisch",
    fr: "Tout dans le cadre du système, tout logique",
  },
  inviteHookSecondTitle50: {
    ru: "План отработал — без единого сбоя",
    en: "Plan worked — no missteps",
    es: "El plan funcionó — sin fallas",
    pt: "O plano funcionou — sem falhas",
    de: "Der Plan hat funktioniert – ohne Fehler",
    fr: "Le plan a fonctionné — sans erreur",
  },
  inviteHookSecondTitle51: {
    ru: "Повторится ли этот паттерн снова?",
    en: "Will this pattern repeat again?",
    es: "¿Se repetirá este patrón?",
    pt: "Será que esse padrão se repetirá?",
    de: "Wird sich dieses Muster wiederholen?",
    fr: "Ce schéma se répétera-t-il ?",
  },
  inviteHookSecondTitle52: {
    ru: "Даст ли рынок такую же структуру в следующий раз?",
    en: "Will the market give the same structure next time?",
    es: "¿El mercado mostrará la misma estructura la próxima vez?",
    pt: "O mercado mostrará a mesma estrutura na próxima vez?",
    de: "Zeigt der Markt beim nächsten Mal dieselbe Struktur?",
    fr: "Le marché montrera-t-il la même structure la prochaine fois ?",
  },
  inviteHookSecondTitle53: {
    ru: "Интересно, как поведёт себя следующая идея",
    en: "Curious to see how the next idea plays out",
    es: "Curioso por ver cómo se desarrolla la próxima idea",
    pt: "Curioso para ver como se desenvolverá a próxima ideia",
    de: "Neugierig, wie sich die nächste Idee entwickelt",
    fr: "Curieux de voir comment la prochaine idée va évoluer",
  },
  inviteHookSecondTitle54: {
    ru: "Стоит ли ждать повторения этого сценария?",
    en: "Is it worth waiting for a repeat of this scenario?",
    es: "¿Vale la pena esperar que se repita este escenario?",
    pt: "Vale a pena esperar que o cenário se repita?",
    de: "Wird sich dieses Szenario wiederholen?",
    fr: "Ce scénario se reproduira-t-il ?",
  },
  inviteHookSecondTitle55: {
    ru: "Будет ли новая волна такой же чистой?",
    en: "Will the next wave be just as clean?",
    es: "¿Será la próxima ola igual de limpia?",
    pt: "Será que a próxima onda será tão limpa quanto esta?",
    de: "Wird die nächste Bewegung genauso sauber sein?",
    fr: "La prochaine vague sera-t-elle aussi claire que celle-ci ?",
  },
  inviteHookSecondTitle56: {
    ru: "Увидим ли похожую динамику снова?",
    en: "Will we see a similar dynamic again?",
    es: "¿Veremos una dinámica parecida otra vez?",
    pt: "Veremos uma dinâmica parecida de novo?",
    de: "Werden wir wieder ähnliche Dynamik sehen?",
    fr: "Verra-t-on à nouveau une dynamique similaire ?",
  },
  inviteHookSecondTitle57: {
    ru: "Повторит ли рынок этот почерк?",
    en: "Will the market repeat this rhythm?",
    es: "¿Repetirá el mercado este ritmo?",
    pt: "O mercado repetirá esse ritmo?",
    de: "Wird der Markt diesen Rhythmus wiederholen?",
    fr: "Le marché répétera-t-il ce rythme ?",
  },
  inviteHookSecondTitle58: {
    ru: "Появится ли возможность сыграть похожий сетап?",
    en: "Will there be a chance to play a similar setup?",
    es: "¿Habrá una oportunidad para un setup similar?",
    pt: "Haverá uma chance de repetir um setup semelhante?",
    de: "Kommt bald ein ähnliches Setup?",
    fr: "Y aura-t-il une occasion de rejouer un setup similaire ?",
  },
  inviteHookSecondTitle59: {
    ru: "Сможет ли дисциплина снова сработать так же чётко?",
    en: "Can discipline perform this sharply again?",
    es: "¿Podrá la disciplina rendir igual de bien otra vez?",
    pt: "A disciplina conseguirá funcionar tão bem novamente?",
    de: "Kann Disziplin wieder so präzise funktionieren?",
    fr: "La discipline pourra-t-elle fonctionner aussi bien à nouveau ?",
  },
  inviteHookSecondTitle60: {
    ru: "Где появится следующий ритм движения?",
    en: "Where will the next rhythm appear?",
    es: "¿Dónde aparecerá el siguiente ritmo del mercado?",
    pt: "Onde surgirá o próximo ritmo do mercado?",
    de: "Wo wird der nächste Marktimpuls entstehen?",
    fr: "Où apparaîtra le prochain rythme du marché ?",
  },
  inviteHookSecondTitle61: {
    ru: "Всё по системе: вход, контроль, выход",
    en: "All by the system: entry, control, exit",
    es: "Todo según el sistema: entrada, control, salida",
    pt: "Tudo dentro do sistema: entrada, controle, saída",
    de: "Alles nach System: Einstieg, Kontrolle, Ausstieg",
    fr: "Tout selon le système : entrée, contrôle, sortie",
  },
  inviteHookSecondTitle62: {
    ru: "Формула стабильна, результат предсказуем",
    en: "Formula holds — consistency stays",
    es: "La fórmula sigue — la consistencia también",
    pt: "A fórmula permanece — a consistência também",
    de: "Die Formel bleibt – das Ergebnis ist konstant",
    fr: "La formule reste la même — les résultats aussi",
  },
  inviteHookSecondTitle63: {
    ru: "Как всегда — метод, а не эмоции",
    en: "As always — method over emotion",
    es: "Como siempre — método antes que emoción",
    pt: "Como sempre — método antes da emoção",
    de: "Wie immer – Methode statt Emotion",
    fr: "Comme toujours — la méthode avant les émotions",
  },
  inviteHookSecondTitle64: {
    ru: "Дисциплина даёт повторяемость",
    en: "Discipline brings repeatability",
    es: "La disciplina genera repetición",
    pt: "A disciplina gera repetição",
    de: "Disziplin schafft Wiederholung",
    fr: "La discipline crée la répétition",
  },
  inviteHookSecondTitle65: {
    ru: "Ритуал тот же — всё сработало",
    en: "Same ritual — it worked again",
    es: "El mismo ritual — volvió a funcionar",
    pt: "O mesmo ritual — funcionou de novo",
    de: "Das gleiche Ritual – wieder funktioniert",
    fr: "Le même rituel — et ça fonctionne encore",
  },
  inviteHookSecondTitle66: {
    ru: "План → исполнение → результат — без отклонений",
    en: "Plan → execution → result — no deviations",
    es: "Plan → ejecución → resultado — sin desvíos",
    pt: "Plano → execução → resultado — sem desvios",
    de: "Plan → Ausführung → Ergebnis – ohne Abweichung",
    fr: "Plan → exécution → résultat — sans déviation",
  },
  inviteHookSecondTitle67: {
    ru: "По схеме, без импровизации",
    en: "By the playbook, no improvisation",
    es: "Según el plan, sin improvisar",
    pt: "Tudo conforme o plano, sem improvisos",
    de: "Alles nach Plan, ohne Improvisation",
    fr: "Tout selon le plan, sans improvisation",
  },
  inviteHookSecondTitle68: {
    ru: "Всё идёт по привычной модели",
    en: "Everything flows within the usual model",
    es: "Todo fluye dentro del modelo habitual",
    pt: "Tudo segue dentro do modelo habitual",
    de: "Alles läuft nach bekanntem Muster",
    fr: "Tout suit le modèle habituel",
  },
  inviteHookSecondTitle69: {
    ru: "Система делает своё — я просто наблюдаю",
    en: "The system does its job — I just observe",
    es: "El sistema hace su trabajo — yo solo observo",
    pt: "O sistema faz o trabalho — eu apenas observo",
    de: "Das System arbeitet – ich beobachte nur",
    fr: "Le système fait son travail — j’observe simplement",
  },
  inviteHookSecondTitle70: {
    ru: "Концепция не меняется, работает стабильно",
    en: "Concept stays the same, steady performance",
    es: "El concepto no cambia, sigue funcionando",
    pt: "O conceito não muda, continua funcionando",
    de: "Das Konzept bleibt gleich – es funktioniert weiter",
    fr: "Le concept reste le même — il fonctionne toujours",
  },
  inviteHookSecondTitle71: {
    ru: "Ещё одна сделка по той же схеме — спокойно",
    en: "Another trade by the same pattern — calm and clear",
    es: "Otra operación bajo el mismo patrón — calma total",
    pt: "Mais uma operação dentro do mesmo padrão — tudo tranquilo",
    de: "Noch ein Trade nach demselben Schema – ruhig und klar",
    fr: "Encore un trade selon le même schéma — calme et clair",
  },
  inviteHookSecondTitle72: {
    ru: "Всё повторяется — и в этом стабильность",
    en: "Everything repeats — and that’s the strength",
    es: "Todo se repite — y ahí está la fuerza",
    pt: "Tudo se repete — e é aí que está a força",
    de: "Alles wiederholt sich – darin liegt die Stärke",
    fr: "Tout se répète — et c’est là que réside la stabilité",
  },
  inviteHookSecondTitle73: {
    ru: "Очередное подтверждение метода",
    en: "Another confirmation of the method",
    es: "Otra confirmación del método",
    pt: "Mais uma confirmação do método",
    de: "Ein weiteres Signal für einen funktionierenden Ansatz",
    fr: "Une autre confirmation de la méthode",
  },
  inviteHookSecondTitle74: {
    ru: "Так выглядит системность в действии",
    en: "That’s what consistency looks like in action",
    es: "Así se ve la consistencia en acción",
    pt: "É assim que a consistência se mostra em ação",
    de: "So sieht Konsistenz in Aktion aus",
    fr: "Voilà à quoi ressemble la constance en action",
  },
  inviteHookSecondTitle75: {
    ru: "Ничего нового — просто дисциплина в работе",
    en: "Nothing new — just discipline at work",
    es: "Nada nuevo — solo disciplina en práctica",
    pt: "Nada novo — apenas disciplina em prática",
    de: "Nichts Neues – nur Disziplin in Bewegung",
    fr: "Rien de nouveau — juste de la discipline en pratique",
  },
  inviteHookSecondTitle76: {
    ru: "Метод проверен — результат предсказуем",
    en: "Method proven — results stay consistent",
    es: "Método probado — resultados estables",
    pt: "Método testado — resultado estável",
    de: "Methode bewährt – Ergebnis stabil",
    fr: "Méthode éprouvée — résultat stable",
  },
  inviteHookSecondTitle77: {
    ru: "Всё стабильно, без эмоциональных качелей",
    en: "Everything stable, no emotional swings",
    es: "Todo estable, sin altibajos emocionales",
    pt: "Tudo estável, sem oscilações emocionais",
    de: "Alles stabil – keine emotionalen Schwankungen",
    fr: "Tout est stable, sans montagnes russes émotionnelles",
  },
  inviteHookSecondTitle78: {
    ru: "Та же структура, тот же порядок, тот же итог",
    en: "Same structure, same rhythm, same outcome",
    es: "La misma estructura, el mismo ritmo, el mismo cierre",
    pt: "A mesma estrutura, o mesmo ritmo, o mesmo fechamento",
    de: "Gleiche Struktur, gleicher Ablauf, gleiches Ende",
    fr: "Même structure, même rythme, même fin",
  },
  inviteHookSecondTitle79: {
    ru: "Повторяемость — лучший показатель надёжности",
    en: "Repetition — the best proof of reliability",
    es: "La repetición — la mejor prueba de fiabilidad",
    pt: "A repetição — a melhor prova de confiabilidade",
    de: "Wiederholung – das beste Zeichen für Stabilität",
    fr: "La répétition — la meilleure preuve de fiabilité",
  },
  inviteHookSecondTitle80: {
    ru: "Сценарий знакомый, результат ожидаемый",
    en: "Familiar scenario, expected result",
    es: "Escenario familiar, resultado esperado",
    pt: "Cenário familiar, resultado esperado",
    de: "Bekanntes Szenario, erwartetes Ergebnis",
    fr: "Scénario familier, résultat attendu",
  },
  inviteHookSecondTitle81: {
    ru: "Главное — сохранить ритм, не эмоции",
    en: "Main thing — keep rhythm, not emotion",
    es: "Lo principal — mantener el ritmo, no la emoción",
    pt: "O essencial — manter o ritmo, não a emoção",
    de: "Das Wichtigste – Rhythmus halten, nicht Emotionen",
    fr: "L’essentiel — garder le rythme, pas les émotions",
  },
  inviteHookSecondTitle82: {
    ru: "Без лишних движений — всё по плану",
    en: "No extra moves — everything by plan",
    es: "Sin movimientos extra — todo según el plan",
    pt: "Sem movimentos desnecessários — tudo conforme o plano",
    de: "Keine unnötigen Bewegungen – alles nach Plan",
    fr: "Aucun mouvement inutile — tout selon le plan",
  },
  inviteHookSecondTitle83: {
    ru: "Качество важнее скорости",
    en: "Quality matters more than speed",
    es: "La calidad importa más que la velocidad",
    pt: "Qualidade acima da velocidade",
    de: "Qualität vor Geschwindigkeit",
    fr: "La qualité avant la vitesse",
  },
  inviteHookSecondTitle84: {
    ru: "Сделка завершена ровно, без перегрузки",
    en: "Trade closed smoothly, no overload",
    es: "Operación cerrada con suavidad, sin carga extra",
    pt: "Operação encerrada suavemente, sem excesso",
    de: "Trade sauber beendet, ohne Überladung",
    fr: "Trade clôturé proprement, sans surcharge",
  },
  inviteHookSecondTitle85: {
    ru: "Риск под контролем — именно так и нужно",
    en: "Risk under control — just as it should be",
    es: "Riesgo bajo control — justo como debe ser",
    pt: "Risco sob controle — exatamente como deve ser",
    de: "Risiko unter Kontrolle – genau so soll es sein",
    fr: "Risque sous contrôle — exactement comme il faut",
  },
  inviteHookSecondTitle86: {
    ru: "Лучше стабильность, чем случайность",
    en: "Better stability than randomness",
    es: "Mejor estabilidad que casualidad",
    pt: "Melhor estabilidade do que acaso",
    de: "Stabilität ist besser als Zufall",
    fr: "Mieux vaut la stabilité que le hasard",
  },
  inviteHookSecondTitle87: {
    ru: "Защищённый результат — это и есть цель",
    en: "Protected outcome — that’s the goal",
    es: "Resultado protegido — ese es el objetivo",
    pt: "Resultado protegido — esse é o objetivo",
    de: "Geschütztes Ergebnis – das ist das Ziel",
    fr: "Résultat protégé — c’est l’objectif",
  },
  inviteHookSecondTitle88: {
    ru: "Без попыток “поймать максимум” — только точность",
    en: "No chase for ‘max gain’ — just precision",
    es: "Sin buscar el ‘máximo’ — solo precisión",
    pt: "Sem tentar ‘pegar o máximo’ — apenas precisão",
    de: "Kein Versuch, das Maximum zu jagen – nur Präzision",
    fr: "Pas besoin de “viser le maximum” — juste de la précision",
  },
  inviteHookSecondTitle89: {
    ru: "Баланс сохранён, капитал спокоен",
    en: "Balance held, capital calm",
    es: "Equilibrio mantenido, capital tranquilo",
    pt: "Equilíbrio mantido, capital tranquilo",
    de: "Gleichgewicht bewahrt, Kapital ruhig",
    fr: "Équilibre préservé, capital serein",
  },
  inviteHookSecondTitle90: {
    ru: "Закрытие без потерь — лучший исход",
    en: "Closed with no losses — best possible exit",
    es: "Cierre sin pérdidas — el mejor desenlace",
    pt: "Fechamento sem perdas — o melhor desfecho",
    de: "Abschluss ohne Verluste – der beste Ausgang",
    fr: "Clôture sans perte — la meilleure issue",
  },
  inviteHookSecondTitle91: {
    ru: "Ещё один цикл завершён — идём дальше",
    en: "Another cycle done — moving forward",
    es: "Otro ciclo cerrado — seguimos adelante",
    pt: "Mais um ciclo encerrado — seguimos em frente",
    de: "Ein weiterer Zyklus beendet – weiter geht’s",
    fr: "Un autre cycle terminé — on continue",
  },
  inviteHookSecondTitle92: {
    ru: "Всё по ритуалу: начало, динамика, финал",
    en: "By the ritual: start, flow, finish",
    es: "Por el ritual: inicio, desarrollo, cierre",
    pt: "Tudo conforme o ritual: início, dinâmica, final",
    de: "Alles nach Ritual: Beginn, Dynamik, Abschluss",
    fr: "Tout selon le rituel : début, dynamique, fin",
  },
  inviteHookSecondTitle93: {
    ru: "Очередной день — очередная история",
    en: "Another day — another story",
    es: "Otro día — otra historia",
    pt: "Mais um dia — mais uma história",
    de: "Ein weiterer Tag – eine neue Geschichte",
    fr: "Une nouvelle journée — une nouvelle histoire",
  },
  inviteHookSecondTitle94: {
    ru: "Процесс не меняется, только рынок",
    en: "Process stays the same, only the market changes",
    es: "El proceso no cambia, solo el mercado",
    pt: "O processo não muda, apenas o mercado",
    de: "Der Prozess bleibt gleich, nur der Markt ändert sich",
    fr: "Le processus reste le même, seul le marché change",
  },
  inviteHookSecondTitle95: {
    ru: "Сделка закрыта — ритм сохранён",
    en: "Trade closed — rhythm maintained",
    es: "Operación cerrada — ritmo mantenido",
    pt: "Operação encerrada — ritmo mantido",
    de: "Trade abgeschlossen – Rhythmus bleibt",
    fr: "Trade terminé — rythme préservé",
  },
  inviteHookSecondTitle96: {
    ru: "Всё по привычному сценарию",
    en: "Everything followed the familiar scenario",
    es: "Todo siguió el escenario habitual",
    pt: "Tudo seguiu o roteiro habitual",
    de: "Alles nach bekanntem Muster",
    fr: "Tout selon le scénario habituel",
  },
  inviteHookSecondTitle97: {
    ru: "Один цикл завершён, другой уже рождается",
    en: "One cycle ends, another begins",
    es: "Un ciclo termina, otro comienza",
    pt: "Um ciclo termina, outro começa",
    de: "Ein Zyklus endet, ein neuer beginnt",
    fr: "Un cycle se termine, un autre commence",
  },
  inviteHookSecondTitle98: {
    ru: "Снова закономерность: дисциплина → результат",
    en: "Same pattern: discipline → result",
    es: "Otra vez la misma lógica: disciplina → resultado",
    pt: "Mais uma vez o mesmo padrão: disciplina → resultado",
    de: "Wieder dieselbe Regelmäßigkeit: Disziplin → Ergebnis",
    fr: "Encore une fois la même logique : discipline → résultat",
  },
  inviteHookSecondTitle99: {
    ru: "Ритуал повторяется, стабильность сохраняется",
    en: "Ritual repeats, stability remains",
    es: "El ritual se repite, la estabilidad sigue",
    pt: "O ritual se repete, a estabilidade se mantém",
    de: "Das Ritual wiederholt sich – Stabilität bleibt",
    fr: "Le rituel se répète — la stabilité demeure",
  },
  inviteHookSecondTitle100: {
    ru: "Всё в том же ритме — шаг за шагом",
    en: "Same rhythm — step by step",
    es: "El mismo ritmo — paso a paso",
    pt: "O mesmo ritmo — passo a passo",
    de: "Gleicher Rhythmus – Schritt für Schritt",
    fr: "Même rythme — pas à pas",
  },
  disclaimer1: {
    ru: "Показываю свой шаг — не совет.",
    en: "Showing my move — not advice.",
    es: "Solo muestro mi movimiento, no es un consejo.",
    pt: "Mostro meu movimento, não é conselho.",
    de: "Ich zeige meinen Schritt – keine Empfehlung.",
    fr: "Je montre mon geste, ce n’est pas un conseil.",
  },
  disclaimer2: {
    ru: "Моё ежедневное действие — не больше.",
    en: "My daily action — nothing more.",
    es: "Mi acción diaria, nada más.",
    pt: "Minha ação diária, só isso.",
    de: "Meine tägliche Handlung, nicht mehr.",
    fr: "Mon geste du jour, rien de plus.",
  },
  disclaimer3: {
    ru: "Запись того, что я сделал — не для подражания.",
    en: "A record of what I did — not for imitation.",
    es: "Solo registro lo que hice, no es para copiar.",
    pt: "Registro o que fiz, não é para repetir.",
    de: "Nur eine Aufzeichnung dessen, was ich getan habe – kein Beispiel.",
    fr: "Un aperçu de ce que j’ai fait, pas à reproduire.",
  },
  disclaimer4: {
    ru: "Мой шаг — не призыв действовать.",
    en: "My own step — not a call to act.",
    es: "Es mi paso, no una invitación a actuar.",
    pt: "É o meu passo, não um convite à ação.",
    de: "Mein Schritt – kein Aufruf zu handeln.",
    fr: "C’est mon pas, pas un appel à agir.",
  },
  disclaimer5: {
    ru: "Один из моих шагов — не руководство.",
    en: "One of my moves — not a guide.",
    es: "Uno de mis pasos, no una guía.",
    pt: "Um dos meus passos, não é um guia.",
    de: "Einer meiner Schritte – keine Anleitung.",
    fr: "L’un de mes gestes, pas un guide.",
  },
  disclaimer6: {
    ru: "Показываю процесс — не инструкцию.",
    en: "Just showing my process — not an instruction.",
    es: "Solo muestro mi proceso, no es una instrucción.",
    pt: "Mostro meu processo, não é uma instrução.",
    de: "Ich zeige nur meinen Ablauf – keine Anleitung.",
    fr: "Je montre simplement mon processus, pas une instruction.",
  },
  disclaimer7: {
    ru: "Моё личное действие — не для повторения.",
    en: "My personal action — not for repetition.",
    es: "Mi acción personal, no para repetir.",
    pt: "Minha ação pessoal, não é para repetir.",
    de: "Meine eigene Handlung – nicht zur Nachahmung.",
    fr: "Mon action personnelle, pas à répéter.",
  },
  disclaimer8: {
    ru: "Момент из моей работы — не предложение.",
    en: "A moment from my work — not a suggestion.",
    es: "Un momento de mi trabajo, no una sugerencia.",
    pt: "Um momento do meu trabalho, não é uma sugestão.",
    de: "Ein Ausschnitt aus meiner Arbeit – kein Vorschlag.",
    fr: "Un moment de mon travail, pas une suggestion.",
  },
  disclaimer9: {
    ru: "Показываю для контекста — не для копирования.",
    en: "Shared for context — not for copying.",
    es: "Lo comparto como contexto, no para copiar.",
    pt: "Compartilho como contexto, não para copiar.",
    de: "Zur Einordnung geteilt – nicht zum Kopieren.",
    fr: "Partagé pour le contexte, pas pour copier.",
  },
  disclaimer10: {
    ru: "Мой способ — не пример.",
    en: "My way of doing — not an example.",
    es: "Así es como lo hago yo, no es un ejemplo.",
    pt: "É o meu jeito de fazer, não um exemplo.",
    de: "So mache ich es – kein Beispiel.",
    fr: "Ma façon de faire, pas un exemple.",
  },
  disclaimer11: {
    ru: "Мои шаги — не ориентир.",
    en: "Only my steps — not for direction.",
    es: "Mis pasos, no una referencia.",
    pt: "Meus passos, não uma referência.",
    de: "Meine Schritte – keine Orientierung.",
    fr: "Mes pas, pas une référence.",
  },
  disclaimer12: {
    ru: "Фиксирую свой путь — не призываю к действиям.",
    en: "Just documenting my path — not inviting action.",
    es: "Solo documento mi camino, no invito a actuar.",
    pt: "Registro meu caminho, não convido à ação.",
    de: "Ich dokumentiere nur meinen Weg – kein Aufruf zu handeln.",
    fr: "Je documente simplement mon parcours, sans inviter à agir.",
  },
  "timeframe-m10": {
    ru: "10м",
    en: "10m",
    es: "10m",
    pt: "10m",
    de: "10m",
    fr: "10m",
  },
  "timeframe-m60": {
    ru: "1ч",
    en: "1h",
    es: "1h",
    pt: "1h",
    de: "1h",
    fr: "1h",
  },
  "timeframe-day": {
    ru: "1Д",
    en: "1D",
    es: "1D",
    pt: "1D",
    de: "1T",
    fr: "1J",
  },
  "timeframe-week": {
    ru: "1Н",
    en: "1W",
    es: "1S",
    pt: "1S",
    de: "1W",
    fr: "1S",
  },
  "timeframe-month": {
    ru: "1М",
    en: "1M",
    es: "1M",
    pt: "1M",
    de: "1M",
    fr: "1M",
  },
  profit: {
    ru: "Результат:",
    en: "Outcome:",
    es: "Resultado:",
    pt: "Resultado:",
    de: "Ergebnis:",
    fr: "Résultat :",
  },
};

export const translate = (lang: string, key: string): string => {
  return translation[key][lang];
};
